import type { ModuleStatus } from "../modules/common";

// order matters here
const STATUS_LEVELS = ["Error", "Warning", "Info", "Unknown"] as const;
export type StatusDetailLevel = (typeof STATUS_LEVELS)[number];

export const STATUS_LEVEL_VALUES = Object.fromEntries(
  STATUS_LEVELS.map((key, index) => [key, index])
) as Record<StatusDetailLevel, number>;

export interface StatusDetailLocation {
  descriptor_key: string;
  material_ids: string[];
  type: "variable";
}

export interface StatusDetail {
  code?: number | null;
  group_code?:
    | "EXPRESSION_FAILURE"
    | "LABEL_FRACTIONS_FAILURE"
    | "MEAN_PROPERTY_DESCRIPTOR_FAILURE"
    | "MEAN_PROPERTY_FAILURE"
    | "ML_FAILURE"
    | "ML_DESCRIPTOR_FAILURE"
    | "MODEL_SELECTION_FAILURE"
    | "SIMPLE_MIXTURE_FAILURE"
    | null;
  level: StatusDetailLevel;
  locations?: StatusDetailLocation[];
  msg: string;
}
export interface Status {
  name: ModuleStatus;
  detail: StatusDetail[];
  info: string[];
}

interface HasMetadataStatus {
  metadata: {
    status: Status;
  };
}

export const isBeingValidated = (ds?: HasMetadataStatus) =>
  Boolean(ds?.metadata.status.name === "VALIDATING");

export const isError = (ds?: HasMetadataStatus) =>
  Boolean(
    ds?.metadata.status.name === "ERROR" ||
    ds?.metadata.status.name === "INVALID"
  );

export const isReady = (ds?: HasMetadataStatus) =>
  Boolean(ds?.metadata.status.name === "READY");

export const isSettled = (ds?: HasMetadataStatus) => isReady(ds) || isError(ds);

export const isCreated = (ds?: HasMetadataStatus) =>
  Boolean(ds?.metadata.status.name === "CREATED");

export const isProcessing = (ds?: HasMetadataStatus) =>
  isBeingValidated(ds) || isCreated(ds);
